<script>
  import Chart from "./../util/chart.js";
  import { afterUpdate } from "svelte";

  export let title;
  export let data = {
    labels: [],
    datasets: []
  };

  let ctx;
  let options = {
    // responsive: true,
    // maintainAspectRatio: false,
    animation: {
      duration: 0
    },
    scales: {
      xAxes: [
        {
          gridLines: {
            display: false,
            drawBorder: false
          }
        }
      ],
      yAxes: [
        {
          gridLines: {
            display: true,
            color: "transparent",
            zeroLineColor: "white",
            zeroLineWidth: 1
          },
          ticks: {
            display: false,
            drawBorder: false
          }
        }
      ]
    },
    legend: {
      display: true
    },
    title: {
      display: true,
    },
    tooltips: {
      mode: "x-axis"
    }
  };

  let chart;
  afterUpdate(() => {
    options.title.display = !!title;
    options.title.text = title;
    let cfg = { type: "bar", data, options };
    if (!chart) {
      chart = new Chart(ctx, cfg);
    } else {
      chart.config.data = data;
      chart.update();
    }
  });
</script>

<canvas width='400' height='200' class="chart time-bar" bind:this={ctx} />
